import { SupabaseRepository } from "./SupabaseRepository";
import type { CustomerRepository } from "@/domain/repositoryInterface/CustomerRepository";
import type { Condition, Page, PageRequest } from "@/domain/repositoryInterface/Repository";
import type { Customer } from "@/domain/types";

export class SupabaseCustomerRepository
  extends SupabaseRepository<"customers">
  implements CustomerRepository
{
  constructor() {
    super("customers");
  }

  async search(params: {
    term?: string;
    where?: Condition[];
    select?: string;
    page: PageRequest;
  }): Promise<Page<Customer>> {
    // deleted_at は当面 where で明示（論理削除は本層に組み込まない方針）
    const conditions: Condition[] = [
      { column: "deleted_at", op: "isNull" },
      ...(params.where ?? []),
    ];

    const term = params.term?.trim();
    if (term) {
      const like = `%${term}%`;
      conditions.push({
        or: [
          { column: "full_name", op: "ilike", value: like },
          { column: "furigana", op: "ilike", value: like },
          { column: "phone1", op: "ilike", value: like },
        ],
      });
    }

    return this.findMany<Customer>({
      ...(params.select ? { select: params.select } : {}),
      where: conditions,
      orderBy: [{ column: "created_at", ascending: false }],
      page: params.page,
      withCount: true,
    });
  }
}
